// ============================================================
// TMR Portal Admin — as colunas da planilha de Taxas da Empresa
// ============================================================
import { bandLabel, formatRateValue, rateTypeLabel } from '../../data/rateFormat';
import { SCOPE_LABEL } from '../../data/rates/status';
import type { CompanyRate } from '../../data/rates/contract';
import type { ExportColumn } from '../../lib/export/types';

/**
 * One Empresa's rates as a spreadsheet (20 §9).
 *
 * **Both values are here**, and that is the point of exporting this list: `standardValue` is what the
 * Empresa is charged normally and `effectiveValue` is what it is charged today — they differ exactly while
 * a temporary window is open, and a file with only one of them would answer the wrong question half the
 * time.
 *
 * The temporary window is flattened into its own columns rather than exported as an object: a cell holding
 * `{value, startDate, endDate}` is unreadable, and the three facts are what somebody filters on.
 */
export const COMPANY_RATE_EXPORT_COLUMNS: ExportColumn<CompanyRate>[] = [
  { header: 'Escopo', value: (r) => SCOPE_LABEL[r.scope] ?? r.scope },
  { header: 'Produto', value: (r) => r.productName ?? (r.productId != null ? String(r.productId) : '') },
  { header: 'Tipo de taxa', value: (r) => (r.rateTypeName ? rateTypeLabel(r.rateTypeName) : String(r.rateTypeId)) },
  { header: 'Motor de aprovação', value: (r) => r.creditEngineTypeName ?? '' },
  { header: 'Faixa de parcelas', value: (r) => bandLabel(r) },
  { header: 'Valor padrão', value: (r) => formatRateValue(r.standardValue, r.rateTypeId) },
  { header: 'Valor padrão (número)', value: (r) => r.standardValue },
  { header: 'Valor vigente', value: (r) => formatRateValue(r.effectiveValue, r.rateTypeId) },
  { header: 'Valor vigente (número)', value: (r) => r.effectiveValue },
  { header: 'Taxa temporária', value: (r) => (r.temporary ? formatRateValue(r.temporary.value, r.rateTypeId) : '') },
  { header: 'Temporária de', value: (r) => r.temporary?.startDate ?? '' },
  { header: 'Temporária até', value: (r) => r.temporary?.endDate ?? '' },
  { header: 'Motivo da temporária', value: (r) => r.temporary?.reason ?? '' },
  // The coupon is what explains a value nobody in this portal typed (08 §8).
  { header: 'Cupom no legado', value: (r) => r.couponId },
  { header: 'Sincronizada com o legado', value: (r) => r.legacySynced },
  { header: 'Taxa no legado', value: (r) => r.legacyRateId },
];
